import api from './api';

export const transactionService = {
  list: async (month?: number, year?: number) => {
    const params: Record<string, any> = {};
    if (month) params.month = month;
    if (year) params.year = year;
    const res = await api.get('/transactions', { params });
    return res.data;
  },

  get: async (id: string) => {
    const res = await api.get(`/transactions/${id}`);
    return res.data;
  },

  create: async (payload: any) => {
    const res = await api.post('/transactions', payload);
    return res.data;
  },

  update: async (id: string, payload: any) => {
    const res = await api.put(`/transactions/${id}`, payload);
    return res.data;
  },

  remove: async (id: string) => {
    const res = await api.delete(`/transactions/${id}`);
    return res.data;
  },
};

export default transactionService;
